import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { Login } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import Tooltip from "@mui/material/Tooltip";
// import Switch from "@mui/material/Switch";
import { LanguageSwitch } from "./LanguageSwitch"; // Import the LanguageSwitch component

import logo from "../../../assets/logo/LOGO-dark.png";

import { useLanguage } from "../../../services/localization/LanguageContex"; // adjust path as needed

const drawerWidth = 240;
const navItems = [
  "Category",
  // "Stories",
  "Discourse",
  "Quiz",
  "Feedback",
];

const pathMap = {
  Category: "./signsCategory",
  Discourse: "./discourse",
  // Stories: "./stories",
  Quiz: "./quiz",
  Feedback: "./feedback",
};

function NavBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [selectedNavItem, setSelectedNavItem] = React.useState("");

  const { language, toggleLanguage, t } = useLanguage();

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleLanguageToggle = (event) => {
    toggleLanguage();
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Box
        component="img"
        src={logo}
        alt="bhsl logo"
        loading="lazy"
        sx={{
          width: 40,
          height: 40,
          mt: 3,
        }}
      />
      <Typography variant="h6" sx={{ my: 2 }}>
        {language==="en"?"BHSL":"འབྲུག་པའི་ལག་བརྡ་སྐད་ཡིག།"}
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton
              component={Link}
              to={pathMap[item]}
              sx={{ textAlign: "center" }}
            >
              <ListItemText primary={t(item)} />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem disablePadding>
          <ListItemButton
            component={Link}
            to="/login"
            sx={{ textAlign: "center" }}
          >
            <ListItemText primary={t("Login")} />
            <Login />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <Typography
            variant="subtitle1"
            sx={{
              textAlign: "center",
              mt: 1,
              ml: 9,
            }}
          >
            {t("Language")}

            <LanguageSwitch
              checked={language === "dz"}
              onChange={handleLanguageToggle}
              inputProps={{ "aria-label": "language toggle" }}
              sx={{ ml: 5 }}
            />
          </Typography>

          {/* <ListItemButton
            component={Link}
            to="/login"
            sx={{ textAlign: "center" }}
          >
            <ListItemText primary={t("Login")} />
            <Login />
          </ListItemButton> */}
        </ListItem>
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        component="nav"
        sx={{
          backgroundColor: "rgba(27,39,58,255)",
        }}
      >
        <Toolbar>
          {/* hamburger menu */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          {/* Logo */}
          <Link to="/home" style={{ textDecoration: "none" }}>
            <Box
              component="img"
              src={logo}
              alt="bhsl logo"
              loading="lazy"
              sx={{
                width: 40,
                height: 40,
                mr: 1,
                display: { xs: "none", md: "block" },
              }}
            />
          </Link>

          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: "none", md: "block" } }}
          >
            <Link to="/home" style={{ textDecoration: "none", color: "#fff" }}>
              {t("Bhutanese Sign Language")}
            </Link>
          </Typography>

          <Box
            sx={{
              display: { xs: "none", md: "block" },
              // alignItems: "center",
              // display: "flex",
            }}
          >
            {navItems.map((item) => (
              <Button
                key={item}
                sx={{
                  color: "#fff",
                  fontWeight:
                    selectedNavItem === pathMap[item] ? "bold" : "none",
                  "&:hover": {
                    backgroundColor: "#313c4d",
                    color: "#fff",
                  },
                }}
                component={Link}
                to={pathMap[item]}
                onClick={() => {
                  setSelectedNavItem(pathMap[item]);
                }}
              >
                {t(item)}
              </Button>
            ))}

            <Tooltip title={t("Login")}>
              <Button sx={{ color: "#fff" }} component={Link} to="/login">
                <PersonIcon />
              </Button>
            </Tooltip>

            {/* language toggle switch */}
            {/* <Switch
              checked={language === "dz"}
              onChange={handleLanguageToggle}
              inputProps={{ "aria-label": "language toggle" }}
              color="default"
              sx={{ ml: 2 }}
            /> */}

            <LanguageSwitch
              checked={language === "dz"}
              onChange={handleLanguageToggle}
              inputProps={{ "aria-label": "language toggle" }}
              // sx={{ ml: 1 }}
            />
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer for mobile view */}
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}

NavBar.propTypes = {
  window: PropTypes.func,
};

export default NavBar;

// import * as React from "react";
// import PropTypes from "prop-types";
// import AppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import CssBaseline from "@mui/material/CssBaseline";
// import Divider from "@mui/material/Divider";
// import Drawer from "@mui/material/Drawer";
// import IconButton from "@mui/material/IconButton";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemText from "@mui/material/ListItemText";
// import MenuIcon from "@mui/icons-material/Menu";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import Button from "@mui/material/Button";
// import { Link } from "react-router-dom";
// import { Login } from "@mui/icons-material";
// import PersonIcon from "@mui/icons-material/Person";
// import Tooltip from "@mui/material/Tooltip";
// import Switch from "@mui/material/Switch";
// import { LanguageSwitch } from "./LanguageSwitch"; // Import the LanguageSwitch component

// import logo from "../../../assets/logo/LOGO-dark.png";

// import { useLanguage } from "../../../services/localization/LanguageContex"; // adjust path as needed

// const drawerWidth = 240;
// const navItems = [
//   "Category",
//   // "Stories",
//   "Discourse",
//   "Quiz",
//   "Feedback",
// ];

// const pathMap = {
//   Category: "./signsCategory",
//   Discourse: "./discourse",
//   // Stories: "./stories",
//   Quiz: "./quiz",
//   Feedback: "./feedback",
// };

// function NavBar(props) {
//   const { window } = props;
//   const [mobileOpen, setMobileOpen] = React.useState(false);
//   const [selectedNavItem, setSelectedNavItem] = React.useState("");

//   const { language, toggleLanguage, t } = useLanguage();

//   const handleDrawerToggle = () => {
//     setMobileOpen((prevState) => !prevState);
//   };

//   const handleLanguageToggle = (event) => {
//     toggleLanguage();
//   };

//   // console.log("Selected Nav Item:", selectedNavItem);
//   const drawer = (
//     <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
//       <Box
//         component="img"
//         src={logo}
//         alt="bhsl logo"
//         loading="lazy"
//         sx={{
//           width: 40,
//           height: 40,
//           mt: 3,
//           // display: { xs: "none", md: "block" }, // 👈 Hide on xs, show on sm+
//         }}
//       />
//       <Typography variant="h6" sx={{ my: 2 }}>
//         BHSL
//       </Typography>
//       <Divider />
//       <List>
//         {navItems.map((item) => (
//           <ListItem key={item} disablePadding>
//             <ListItemButton
//               component={Link}
//               to={pathMap[item]}
//               sx={{ textAlign: "center" }}
//             >
//               {/* <ListItemText primary={item} /> */}
//               <ListItemText primary={t(item)} />
//             </ListItemButton>
//           </ListItem>
//         ))}
//         <ListItem disablePadding>
//           <ListItemButton
//             component={Link}
//             to="/login"
//             sx={{ textAlign: "center" }}
//           >
//             <ListItemText primary="Login" />
//             <Login />
//           </ListItemButton>
//         </ListItem>
//       </List>
//     </Box>
//   );

//   const container =
//     window !== undefined ? () => window().document.body : undefined;

//   return (
//     <Box sx={{ display: "flex" }}>
//       <CssBaseline />
//       <AppBar
//         component="nav"
//         sx={{
//           backgroundColor:
//             // 'rgba(0,65,159,255)'
//             "rgba(27,39,58,255)",
//           // 'rgba(54,79,103,255)'
//         }}
//       >
//         <Toolbar>
//           {/* hambuger menu */}
//           <IconButton
//             color="inherit"
//             aria-label="open drawer"
//             edge="start"
//             onClick={handleDrawerToggle}
//             sx={{ mr: 2, display: { sm: "none" } }}
//           >
//             <MenuIcon />
//           </IconButton>

//           {/* Logo */}
//           <Link to="/home" style={{ textDecoration: "none" }}>
//             <Box
//               component="img"
//               src={logo}
//               alt="bhsl logo"
//               loading="lazy"
//               sx={{
//                 width: 40,
//                 height: 40,
//                 mr: 1,
//                 display: { xs: "none", sm: "block" }, // 👈 Hide on xs, show on sm+
//               }}
//             />
//           </Link>

//           <Typography
//             variant="h6"
//             component="div"
//             sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
//           >
//             <Link to="/home" style={{ textDecoration: "none", color: "#fff" }}>
//               Bhutanese Sign Language
//             </Link>
//           </Typography>

//           <Box 
//           sx={{ display: { xs: "none", sm: "block" } }}
//             //  sx={{
//             //   display: { xs: "none", sm: "block" },
//             //   alignItems: "center",
//             //   display: "flex",
//             // }}
//           >
//             {navItems.map((item) => (
//               <Button
//                 key={item}
//                 sx={{
//                   color: "#fff",
//                   fontWeight:
//                     selectedNavItem === pathMap[item] ? "bold" : "none",

//                   "&:hover": {
//                     backgroundColor: "#313c4d", // change this to any hover color you like
//                     color: "#fff",
//                   },
//                 }}
//                 component={Link}
//                 to={pathMap[item]}
//                 onClick={() => {
//                   setSelectedNavItem(pathMap[item]);
//                 }}
//               >
//                 {item}
//               </Button>
//             ))}

//             <Tooltip title="Admin Login">
//               <Button sx={{ color: "#fff" }} component={Link} to="/login">
//                 <PersonIcon />
//               </Button>
//             </Tooltip>

//             <LanguageSwitch
//               checked={language === "dz"}
//               onChange={handleLanguageToggle}
//               inputProps={{ "aria-label": "language toggle" }}
//               // sx={{ ml: 5 }}
//             />
//           </Box>
//         </Toolbar>
//       </AppBar>

//       {/* Drawer for mobile view */}
//       <nav>
//         <Drawer
//           container={container}
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleDrawerToggle}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": {
//               boxSizing: "border-box",
//               width: drawerWidth,
//             },
//           }}
//         >
//           {drawer}
//         </Drawer>
//       </nav>
//     </Box>
//   );
// }

// NavBar.propTypes = {
//   window: PropTypes.func,
// };

// export default NavBar;
